import { API_URL } from '../../config/connect';

const getModerationStats = async () => {
  try {
    const token = localStorage.getItem("google_id_token");
    
    if (!token) {
      throw new Error("No token found. User is not signed in.");
    }

    const response = await fetch(`${API_URL}/api/v1/moderation/stats`, {
      method: 'GET',
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error('Error fetching moderation stats:', error);
    throw error;
  }
};

export default getModerationStats;

